import "./styles.scss";

export const Spinner = (props: any) => {
    const color = props.color ?? "#2D2D2D";
    const size = props.size ?? 60;

    return (
        <div className="crealo-spinner" style={props.sx}>
            <svg width={size} height={size} viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                <style>
                    {`
                @keyframes fadeInOut {
                  0% { opacity: 0; transform: scale(0.95); }
                  25% { opacity: 1; transform: scale(1); }
                  50% { opacity: 1; }
                  75% { opacity: 0; }
                  100% { opacity: 0; }
                }

                .segment {
                  opacity: 0;
                  transform-origin: center;
                  animation: fadeInOut 3.75s infinite;
                }

                .segment-0 {
                  animation-delay: 0s;
                }
                .segment-1 {
                  animation-delay: 0.5s;
                }
                .segment-2 {
                  animation-delay: 1s;
                }
                .segment-3 {
                  animation-delay: 1.5s;
                }

                `}
                </style>
                {[
                    "M149.995 49.9524C130.278 69.6687 106.306 75.695 81.2193 68.7833L68.7284 81.2738C75.6403 106.359 69.6519 130.293 49.9349 150.01L0 100.057C19.7169 80.3408 25.6958 56.4071 18.7934 31.3214L31.2843 18.8309C56.3708 25.7426 80.3434 19.7163 100.06 0L150.005 49.9429L149.995 49.9524Z",
                    "M250.046 150C230.329 130.284 224.303 106.312 231.215 81.2262L218.724 68.7357C193.637 75.6474 169.703 69.6592 149.986 49.9429L199.94 0.00952018C219.657 19.7258 243.591 25.7045 268.678 18.8024L281.168 31.2928C274.257 56.3785 280.283 80.3503 300 100.067L250.056 150.01L250.046 150Z",
                    "M149.995 250.048C169.712 230.331 193.685 224.305 218.771 231.217L231.262 218.726C224.35 193.641 230.339 169.707 250.056 149.99L300 199.933C280.283 219.65 274.304 243.583 281.207 268.669L268.716 281.16C243.629 274.248 219.657 280.274 199.94 299.99L149.995 250.048Z",
                    "M49.9445 150C69.6614 169.716 75.6879 193.688 68.776 218.774L81.2669 231.264C106.353 224.353 130.288 230.341 150.005 250.057L100.06 300C80.3434 280.284 56.4089 274.305 31.3224 281.207L18.8315 268.717C25.7434 243.631 19.7169 219.659 0 199.943L49.9445 150Z",
                ].map((d, index) => (
                    <path key={index} className={`segment segment-${index}`} d={d} fill={color} />
                ))}
            </svg>
        </div>
    );
};
